var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fastok"},[_c('tl-icon',{attrs:{"icon":"check"}}),_vm._v(" "),(!_vm.shortForm)?_c('span',[_vm._v(_vm._s(_vm.$t('common.instant-confirmation')))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }